import { render, staticRenderFns } from "./newss.vue?vue&type=template&id=163083ff&scoped=true"
import script from "./newss.vue?vue&type=script&lang=js"
export * from "./newss.vue?vue&type=script&lang=js"
import style0 from "./newss.vue?vue&type=style&index=0&id=163083ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163083ff",
  null
  
)

export default component.exports